<div class="holes-map" [class.holes-map--3d]="state.mapMode() === '3d'">

  <!-- ── Top | 3D toggle ──────────────────────────────────────────────────── -->
  <div class="holes-map__toolbar">
    <app-segmented-control
      [options]="modeOptions()"
      [value]="state.mapMode()"
      dataAttrPrefix="holes-map-mode"
      (valueChange)="onModeChange($event)" />
  </div>

  @if (state.mapMode() === 'top') {
    <!-- OpenLayers target — the map instance attaches here -->
    <div class="holes-map__canvas" #mapTarget data-attr="holes-map-canvas"></div>

    @if (!state.isLoading() && !state.holes().length) {
      <p class="holes-map__empty">{{ 'HOLES_TAB.NO_HOLES' | translate }}</p>
    }

    <div class="holes-map__zoom">
      <button type="button" class="holes-map__zoom-btn"
        data-attr="holes-map-zoom-in"
        [attr.aria-label]="'HOLES_TAB.ZOOM_IN' | translate"
        (click)="zoom(1)">
        <img src="assets/icon/new_icon/zoom_in.svg" alt="">
      </button>
      <button type="button" class="holes-map__zoom-btn"
        data-attr="holes-map-zoom-out"
        [attr.aria-label]="'HOLES_TAB.ZOOM_OUT' | translate"
        (click)="zoom(-1)">
        <img src="assets/icon/new_icon/zoom_out.svg" alt="">
      </button>
    </div>
  } @else {
    <div class="holes-map__viewer" data-attr="holes-map-3d">
      @if (state.blastId(); as blastId) {
        <app-blast3-dviewer-lazy #viewer3d [tirId]="blastId" [geologyModel]="state.geologyModel()" />
      }
    </div>

    <div class="holes-map__pad">
      @for (move of panMoves; track move.id) {
        <button type="button"
          [class]="'holes-map__zoom-btn holes-map__pad-btn holes-map__pad-btn--' + move.id"
          [attr.title]="move.label | translate"
          [attr.aria-label]="move.label | translate"
          (click)="pan3d(move.dx, move.dy)"
          [attr.data-attr]="'holes-map-3d-move-' + move.id">
          <img src="assets/icon/new_icon/arrow-left.svg" alt="">
        </button>
      }
    </div>
  }

</div>
